import React, { Component } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import swal from 'sweetalert'
import { Col, Button, Row } from 'react-bootstrap'
import { Typeahead } from 'react-bootstrap-typeahead'

import { _renderUserMenuItemChildren } from '../../../functions/reactTypeaheadRenderMenuItemChildren'

import { editUser } from '../../login/reducers/manageLogin'

class ActivateDeactivateUsers extends Component {

    state = {
        userToActivate: [],
        userToDeactivate: [],
    }

    changeUserToActivate = (userToActivate) => this.setState({ userToActivate })

    changeUserToDeactivate = (userToDeactivate) => this.setState({ userToDeactivate })

    handleActivateOrDeactivate = (user, is_active) => {
        if (user[0]) {

            user = user[0]

            let successText, errorText

            if (is_active) {
                successText = "The user has been activated"
                errorText = "There was an error promoting the user"
            } else {
                successText = "The user has been deactivated"
                errorText = "There was an error deactivating the user"
            }

            axios({
                method: "PATCH",
                url: `${user.url}toggle_active/`,
                headers: { "Authorization": "Bearer " + localStorage.getItem("token") },
                data: { is_active }
            })
                .then(response => {
                    swal({
                        title: "Success",
                        text: successText,
                        icon: "success",
                        button: "Continue",
                    })

                    this.props.editUser({ ...user, is_active })

                    this.setState({
                        userToActivate: [],
                        userToDeactivate: [],
                    })
                })
                .catch(error => {
                    swal({
                        title: "Error",
                        text: errorText,
                        icon: "error",
                        button: "Continue",
                    })
                })
        }
    }


    render() {

        const { userToDeactivate, userToActivate } = this.state

        const activatedUsers = this.props.users.filter(user => user.is_active && user.id !== this.props.currentUser.pk)
            .sort((a, b) => a.first_name.localeCompare(b.first_name))

        const deactivatedUsers = this.props.users.filter(user => !user.is_active && user.id !== this.props.currentUser.pk)
            .sort((a, b) => a.first_name.localeCompare(b.first_name))

        return (
            <div id="ActivateDeactivateUsers">
                <h4>Deactivate</h4>
                <Row>
                    <Col xs={8} sm={6} md={6}>
                        <div>
                            <Typeahead
                                id="UserToDeactivateTypeahead"
                                clearButton
                                labelKey={user => `${user.first_name} ${user.last_name}`}
                                multiple={false}
                                renderMenuItemChildren={_renderUserMenuItemChildren}
                                selected={userToDeactivate}
                                options={activatedUsers}
                                placeholder="Select user..."
                                onChange={this.changeUserToDeactivate}
                            />
                        </div>
                    </Col>
                    <Col xs={4} sm={6} md={6}>
                        <Button
                            onClick={() => this.handleActivateOrDeactivate(userToDeactivate, false)}
                            disabled={!userToDeactivate.length}
                            bsStyle="primary"
                        >
                            Deactivate
                        </Button>
                    </Col>
                </Row>

                <br />

                <h4>Activate</h4>
                <Row>
                    <Col xs={8} sm={6} md={6}>
                        <div>
                            <Typeahead
                                id="UserToActivateTypeahead"
                                clearButton
                                labelKey={user => `${user.first_name} ${user.last_name}`}
                                multiple={false}
                                renderMenuItemChildren={_renderUserMenuItemChildren}
                                selected={userToActivate}
                                options={deactivatedUsers}
                                placeholder="Select user..."
                                onChange={this.changeUserToActivate}
                            />
                        </div>
                    </Col>
                    <Col xs={4} sm={6} md={6}>
                        <Button
                            onClick={() => this.handleActivateOrDeactivate(userToActivate, true)}
                            disabled={!userToActivate.length}
                            bsStyle="primary"
                        >
                            Activate
                        </Button>
                    </Col>
                </Row>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        users: state.manageLogin.users,
        currentUser: state.manageLogin.user
    }
}

export default connect(mapStateToProps, { editUser })(ActivateDeactivateUsers)



// WEBPACK FOOTER //
// ./src/routes/manager/components/ActivateDeactivateUsers.js